import styled, { css, keyframes } from 'styled-components';
import { darken, lighten } from 'polished';

const animationLoading = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(350deg);
  }
`;

interface ButtonProps {
  background: string;
  color: string;
  effect?: boolean;
  loading?: boolean;
}

export const Container = styled.button<ButtonProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border: 2px solid transparent;
  border-radius: 0.5rem;
  text-align: center;
  height: 3.2rem;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.9rem;
  width: 100%;
  background-color: ${({ background }) => background};
  color: ${({ color }) => color};
  transition: all 0.4s linear;
  white-space: pre-wrap;
  cursor: pointer;

  &:hover {
    background: ${({ background }) => darken(0.06, background)};
  }

  &:focus {
    box-shadow: 0 0 0 3px ${({ background }) => lighten(0.1, background)};
  }

  span {
    margin-left: 3px;
  }

  @media (max-width: 768px) {
    span {
      display: none;
    }
  }

  &:disabled {
    opacity: 0.7;
  }

  ${({ loading }) => loading
    && css`
      svg {
        animation: ${animationLoading} 0.9s linear infinite;
      }
    `}
`;
